import React from 'react';
import logo from '../Common/Images/devologyio_logo.png';

function Footer() {
  const currentYear = new Date().getFullYear();

  // Get Amplify deployment ID from environment variables
  const deploymentId = process.env.REACT_APP_AMPLIFY_BUILD_ID
    || process.env.AWS_COMMIT_ID
    || 'dev';

  return (
    <footer className="app-footer mt-5 py-4">
      <hr className="footer-divider mb-4" />
      <div className="container-custom">
        <div className="row align-items-center">
          <div className="col-md-4 mb-3 mb-md-0">
            <img src={logo} alt="DEVOLOGY.IO logo" className="footer-logo" />
          </div>
          <div className="col-md-4 text-center mb-3 mb-md-0">
            <div className="version-badge">
              <span className="version-label">Deployment</span>
              {' '}
              <span className="version-number">{deploymentId.substring(0, 8)}</span>
            </div>
          </div>
          <div className="col-md-4 text-md-end">
            <a
              href="https://devology.io/"
              className="footer-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Development by DEVOLOGY.IO
            </a>
            <div className="copyright text-muted mt-2">
              &copy;
              {' '}
              {currentYear}
              {' '}
              All rights reserved
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
